export default {"src":"/_next/static/media/youtube-multimedia.eb043891.svg","height":85,"width":381};